import GeoJSON from "ol/format/GeoJSON";
import { toLonLat } from "ol/proj";

import { STYLE_MD_STATION, STYLE_MD_VARIABLE_KEY } from "../constants";

let layers;

/**
 * Returns the first feature from the mapbox layer related to a station.
 */
const getStationFromTopographicLayer = async (
  pixel,
  topographicLayer,
  stationsIds,
) => {
  const style = topographicLayer?.mbMap?.getStyle();
  if (!style?.layers) {
    return null;
  }

  if (!layers) {
    layers = style.layers
      .filter((layer) => {
        return layer.metadata?.[STYLE_MD_VARIABLE_KEY] === STYLE_MD_STATION;
      })
      .map((layer) => layer.id);
  }

  const vtFeatures = topographicLayer.mapLibreMap.queryRenderedFeatures(pixel, {
    layers,
  });
  const format = new GeoJSON({
    featureProjection: "EPSG:3857",
  });
  const first = vtFeatures
    .map((feat) => format.readFeature(feat))
    .find((feat) => stationsIds.includes(parseInt(feat.get("uic_ref"), 10)));
  return first;
};

export default getStationFromTopographicLayer;
